import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { Alert, Box, Button, FormField, Link, Popover, SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiEyeOffOutline, mdiIncognitoCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { parse } from 'date-fns';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemPoll } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, getUser, setLoading } from '../../../../commons/functions';


export const MembersEtcPollsAnswersPage = () => {

  const { data, menu } = useGlobalState();
  const [poll, setPoll] = useState<ItemPoll | null>(null);
  const [idPoll, setIdPoll] = useState<number>(0);
  const [title, setTitle] = useState<string>("Inscripciones");


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) handleGetPoll(id ? parseInt(id) : 0);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleGetPoll = async (idPoll: number) => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/polls/get',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          idPoll: idPoll,
        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.poll) {
        if (data.poll.isActivePoll === 0) {
          window.location.hash = "#members/etc/polls"
        } else {
          setPoll(data.poll);
        }
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (idPoll === 0) {
      setTitle("Inscripciones");
    } else {
      setTitle("Estado " + (poll ? poll.poll : ""));
    }
  }, [idPoll]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      setIdPoll(id ? parseInt(id) : 0);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {
    if (idPoll !== 0) {
      handleGetPoll(idPoll);
    }
  }, [idPoll]);

  const columns = [
    {
      id: "index",
      header: "",
      cell: (item: any) => item.index,
      width: 30
    },
    {
      id: "user",
      header: "Usuario",
      cell: (item: any) => item.dateAnswer !== "" ? <FormField constraintText={item.dateAnswer} label={item.displayName}></FormField> : item.displayName,
      maxWidth: 120,
    },
    ...(poll?.questions || []).map((q, index) => ({
      id: `q_${q.idQuestion}`,
      header:
        <Popover dismissButton={false}
          triggerType="custom"
          size="small"
          position="bottom"
          header={`${q.description === "" ? "" : q.question}`}
          content={<Box padding="s">{q.description === "" ? q.question : q.description}</Box>}>
          <BadgeCustom color="blue">{(index + 1).toString()}</BadgeCustom>
        </Popover>,
      cell: (item: Record<string, any>) => item[`q_${q.idQuestion}`] ? item[`q_${q.idQuestion}`] === "" ? "------" : item[`q_${q.idQuestion}`] : "------",
      maxWidth: 200,
    })),
  ];

  const usersMap: Record<
    number,
    { displayName: React.ReactNode;[key: string]: any }
  > = {};

  poll?.answers?.forEach((a) => {
    if (!usersMap[a.idUser]) {
      const user = getUser(a.idUser, data);
      usersMap[a.idUser] = {
        displayName: user?.displayName ?? <><Icon path={mdiIncognitoCircle} size={1} /> Anónimo</>,
        dateAnswer: a.dateAnswer ?? "",
      };
    }
    usersMap[a.idUser][`q_${a.idQuestion}`] = (
      a.visibilityAnswer === -1 ?
        <><Icon path={mdiEyeOffOutline} size={1} /> Privada</> :
        a.answer);
  });

  const parseCustomDate = (dateStr: string): number => {
    if (!dateStr) return 0;
    const parsedDate = parse(dateStr, "dd-MM-yyyy HH:mm", new Date());
    const time = parsedDate.getTime();
    return isNaN(time) ? 0 : time;
  };

  const sortedUsersArray = Object.entries(usersMap)
    .sort(([, a], [, b]) => {
      const dateA = parseCustomDate(a.dateAnswer);
      const dateB = parseCustomDate(b.dateAnswer);
      return dateA - dateB;
    })
    .map(([idUser, userData]) => ({
      idUser: Number(idUser),
      ...userData
    }));

  const rows = Object.values(sortedUsersArray.map((user: any, index: number) => ({
    ...user,
    index: index + 1
  })));
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1"
            info={poll && poll.publicResults === 1 && (
              <BadgeCustom color={poll.totalUsers === 0 ? "light" : "blue"}>{poll.totalUsers === 0 ? "Sin inscritos" : `Inscrito${poll.totalUsers > 1 ? "s" : ""}: ${poll.totalUsers}`}</BadgeCustom>
            )}

            actions={<>{idPoll !== 0 ? <Button variant='link' onClick={() => {
              setPoll(null)
              window.location.hash = `#members/etc/polls`;
            }}>Volver</Button> : ""}<Favorites /></>}>{poll ? poll?.poll : "Inscripciones"}</Header>
          {poll && (
            <SpaceBetween size="s">
              <div
                style={{ marginBottom: '16px' }}
                dangerouslySetInnerHTML={{
                  __html: poll.description.replace(/\n/g, "<br>"),
                }}
              />
              <Box variant="p">Fecha de cierre: {poll.dateClose} a las {poll.timeClose}</Box>
              {poll.hasStarted === 0 && (
                <Alert type="info" header="La inscripción no está activa" dismissible={false}>
                  La fecha de inicio de esta inscripción aún no ha llegado. Por favor, vuelve más tarde para participar.
                </Alert>
              )}
              {poll.hasEnded === 1 && (
                <Alert type="info" header="La inscripción ha finalizado" dismissible={false}>
                  La fecha de cierre de esta inscripción ya ha pasado. Gracias por tu interés en participar.
                </Alert>
              )}
              {poll && poll.publicAnswers === 0 && (
                <Alert type="error" header="Respuestas privadas" dismissible={false}>
                  Las respuestas de esta inscripción son privadas y no están disponibles para su visualización.
                </Alert>
              )}
              {poll.hasStarted === 1 && poll.publicAnswers === 1 && (
                <Table
                  stickyColumns={{
                    first: 1,
                    last: 0
                  }}
                  wrapLines
                  cellVerticalAlign='top'

                  columnDefinitions={columns}
                  items={rows}
                  header={
                    poll.publicResults === 1 && ((poll.liveResults === 1 && poll.hasEnded === 0) || poll.hasEnded === 1) && (
                      <Link onClick={() => window.location.hash = `members / etc / polls.results ? id = ${poll.idPoll}`}>Resultados de inscripción</Link>
                    )}
                  stickyHeader
                  variant="full-page"
                />
              )}
            </SpaceBetween>
          )}
        </SpaceBetween>
      }
    />
  );
};
